// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1cerU","bigColWidth":"Table_bigColWidth__1UbB1","biggerColWidth":"Table_biggerColWidth__LFa1y","row":"Table_row__1zmGn","col":"Table_col__2vSlv"};